module.exports = __webpack_public_path__ + "static/media/logo-side.3ef6ec24.png";